import getStore from '../store/store';
import { DropViewState, DraggableItemTypes } from 'owa-dnd';
import { getDraggedItemType } from 'owa-module-dnd-store';
import { OwaDate } from 'owa-datetime';

export function getCalendarTabDropState(): DropViewState {
    return getStore().calendarTabDropViewState;
}

export function getTimePanelDropState(): DropViewState {
    return getStore().timePanelDropViewState;
}

export function getDropBoxDropState(): DropViewState {
    return getStore().dropBoxDropViewState;
}

export function shouldShowCalendarTabHoverHint(): boolean {
    return (
        getCalendarTabDropState().draggableItemType === DraggableItemTypes.MailListRow ||
        getDraggedItemType() === DraggableItemTypes.MailListRow
    );
}

export function getLastDragOverHeader(): OwaDate {
    return getStore().lastDragOverHeader;
}

export function isHoveringOverDayDropHint(): boolean {
    return getStore().shouldShowHoverDayDrop;
}

export function getDayViewDropTime(): OwaDate | null {
    return getStore().dayViewDropTime;
}
